// Shared dnd-kit sensor config for the web editor (Doc 06 §7): pointer drags need a
// small movement threshold so plain clicks (row edit, checkbox) aren't swallowed, and
// the keyboard sensor gives arrow-key drags on the focused handle for accessibility.

import { KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

export const useDndSensors = (): ReturnType<typeof useSensors> =>
  useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
